import React from 'react';
import './style.css';

function ReactFloaterJs({ children, index }) {
  const animationDelay = `${index * 0.7}s`;
  return (
    <div className="react-floater-animated" style={{ animationDelay }}>
      {children}
    </div>
  );
}

export default ReactFloaterJs;
